import React from 'react';
import { SvgIcon } from '../../common/SvgIcon';
import { simpleIconPropsTypes } from '../propTypes';

export const IconWorld = (props) => {
  const { width, height } = props;

  return (
    <SvgIcon width={width || 38} height={height || 42} viewBox="0 0 38 42">
      <path
        transform="translate(0, 9)"
        d="M12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm-7.2 9c0-.549.072-1.089.189-1.602L9.291 14.7v.9c0 .99.81 1.8 1.8 1.8v1.737C7.554 18.687 4.8 15.663 4.8 12zm12.501 4.86a1.794 1.794 0 0 0-1.71-1.26h-.9v-2.7c0-.495-.405-.9-.9-.9h-5.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369C17.328 6.393 19.2 8.985 19.2 12a7.192 7.192 0 0 1-1.899 4.86z"
        fill="#4E5978"
        fill-rule="nonzero"
      />
    </SvgIcon>
  );
};

IconWorld.propTypes = simpleIconPropsTypes;
